import React, { useMemo } from 'react';
import { InView } from 'react-intersection-observer';

import Spinner from '@components/Spinner';
import useEventTracking from '@hooks/useEventTracking';
import useRecommendedReporters from '@hooks/useRecommendedReporters';
import { TrackingLocation, impression } from '@tracking';

import ReporterCard from './ReporterCard';
import ForYouSection from './Section';
import { FOR_YOU_ENGAGEMENT_LABELS, FOR_YOU_SECTION_IDS } from './constants';
import useRegisterSection from './useRegisterSection';

const ForYouReporters = () => {
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.Reporters,
  });
  const { reporters, followsReporters, isLoadingReporters } = useRecommendedReporters();

  const reportersDisplayText = useMemo(() => {
    if (!reporters) return FOR_YOU_ENGAGEMENT_LABELS.NotEngaged.Reporters;

    return followsReporters
      ? FOR_YOU_ENGAGEMENT_LABELS.Engaged.Reporters
      : FOR_YOU_ENGAGEMENT_LABELS.NotEngaged.Reporters;
  }, [followsReporters, reporters]);

  useRegisterSection(FOR_YOU_SECTION_IDS.Reporters, isLoadingReporters || !!reporters?.length);

  if (!isLoadingReporters && !reporters?.length) return null;

  return (
    <ForYouSection
      id={FOR_YOU_SECTION_IDS.Reporters}
      highlight={reportersDisplayText.label}
      subtitle={reportersDisplayText.subtitle}
      title={reportersDisplayText.title}
    >
      <Track>
        <InView
          onChange={(inView) => {
            inView && trackEvent(impression({ impressionElement: FOR_YOU_SECTION_IDS.Reporters }));
          }}
          triggerOnce
        >
          <div className="-mx-16 flex flex-row flex-nowrap gap-16 overflow-x-auto px-16 sm:mx-0 sm:px-0 md:justify-between md:gap-112 lg:gap-64">
            {!isLoadingReporters && reporters ? (
              reporters.map((reporter) => <ReporterCard key={reporter.id} reporter={reporter} />)
            ) : (
              <Spinner marginY="small" />
            )}
          </div>
        </InView>
      </Track>
    </ForYouSection>
  );
};

export default ForYouReporters;
